/**
 * filterRail.tsx
 */
import ArrowsSelector from '../nav/arrowsSelector';
import Category from '@shared/classes/category';
import ChannelFilterSearch from '@components/elements/filter/channelFilterSearch';
import FilterArrow from '@components/elements/filter/filterArrow';
import FilterButton from '@components/elements/buttons/ui/filterButton';
import FilterRailWrapperContainer from '@components/atoms/container/filterRailWrapperContainer';
import Focus from '@shared/types/enums/focus';
import MainContext from '@shared/components/utils/context/mainContext';
import useRail from '../../lib/useRail';
import useStableSelectHandler from '../../lib/useStableSelectHandler';
import { selectCategory } from '@shared/store/slices/main.slice';
import { useAppSelector } from '@shared/store/hooks';
import { memo, useContext } from 'react';

/**
 * Filter rail component. Displays several filter buttons that can filter the rail items.
 * It also displays a search button that can search for items in the rail.
 */
function FilterRail() {
  const { config, filter, selectAsset } = useContext(MainContext);
  const category = useAppSelector(selectCategory);
  const { focused, hovered, hIndex, callbacks } = useRail(
    filter?.id || '',
    Focus.FILTER_RAIL
  );
  const getClickHandler = useStableSelectHandler(filter?.id || '', selectAsset);

  return (
    <FilterRailWrapperContainer
      displayRail={config.display.filter}
      {...callbacks}
    >
      {config.display.search ? <ChannelFilterSearch /> : null}
      {hIndex > 0 ? <FilterArrow /> : null}
      {(filter?.data as Category[])?.map((item, idx: number) => {
        if (hIndex > idx) return null;
        return (
          <FilterButton
            key={item.id}
            active={category?.id === item.id || (!item.id && !category)}
            focused={focused && hIndex === idx}
            text={item.title}
            onClick={getClickHandler(idx)}
          />
        );
      })}
      <ArrowsSelector
        hovered={hovered}
        hasTitle={config.display.search}
        rail={filter}
        hIndex={hIndex}
      />
    </FilterRailWrapperContainer>
  );
}

export default memo(FilterRail);
